import { FC, useContext } from "react";
import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import cross from "../../assets/images/cross.svg";
import useStyles from "../Styles/ProjectModalStyles";
import { ConfirmGainsModalProps } from "../../interfaces";
import WalletContext from "../../store/Wallet/WalletContext";
import { useHistory } from "react-router-dom";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";

const ConfirmationModel: FC<ConfirmGainsModalProps> = ({
  id,
  open,
  setOpen,
}) => {
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const { gainsBalance } = useContext<any>(WalletContext);
  const { subscriptions, totalTickets } = useContext<any>(SubscriptionContext);

  const classes = useStyles();
  const history = useHistory();

  const handlewhitelisting = () => {
    localStorage.setItem("poolId", id);
    history.push(`/lock-tokens/${id}`);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Box component="section">
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.modalpages}
        >
          <Box
            ml={isActive ? "20px" : 7}
            my={isActive ? "20px" : 7}
            mr={isActive ? "20px" : 4}
            className="relative-box"
          >
            {!isActive && (
              <img
                src={cross}
                alt=""
                className="cross-icon"
                onClick={handleClose}
              />
            )}
            <ProjectPoolHeading title1="GAINS " title2="Confirmation" />
            <Box>
              <Typography variant="body1" className="c-text">
                You have
                <Typography color="primary" component="span">
                  {" "}
                  {gainsBalance} GAINS,
                </Typography>{" "}
                additionally, you have
                <Typography color="primary" component="span">
                  {" "}
                  {totalTickets} ticket{totalTickets > 1 ? "s" : ""},
                </Typography>{" "}
                from previous subscription{subscriptions.length > 1 ? "s" : ""}.
                You can apply for the whitelist.
              </Typography>
            </Box>

            <Box mt={isActive ? 3 : 5}>
              <Button
                onClick={handlewhitelisting}
                variant="contained"
                color="secondary"
                className="button-buy"
              >
                apply for whitelisting
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default ConfirmationModel;
